module.exports = __webpack_public_path__ + "static/plflag-d27d418c2fb7184bc93c9ce1226cdcee.svg";